export class ClienteAnaliseMercadoSearchClienteOptions {
    // Análise de Mercado
    canOpenAnaliseMercado: boolean;

    // Cliente
    canOpenCliente: boolean;
    canPreBaixarCliente: boolean;
    canBaixarCliente: boolean;

    // Central de Compras
    canInsertCentralCompra: boolean;
    canEditCentralCompra: boolean;
    canInsertParticipanteCentralCompra: boolean;

    /** Verifica se possui alguma opção habilitada */
    hasAnyOption(): boolean {
        return this.hasOptionsAnaliseMercado() ||
                this.hasOptionsCliente() ||
                this.hasOptionsCentralCompra();
    }

    /** Verifica se possui alguma opção referente à análise de mercado habilitada */
    hasOptionsAnaliseMercado(): boolean {
        return this.canOpenAnaliseMercado;
    }


    /** Verifica se possui alguma opção referente ao cliente  habilitada */
    hasOptionsCliente(): boolean {
        return this.canOpenCliente ||
                this.canPreBaixarCliente ||
                this.canBaixarCliente;
    }

    /** Verifica se possui alguma opção referente a central de compras habilitada */
    hasOptionsCentralCompra() {
        return this.canInsertCentralCompra ||
                this.canEditCentralCompra ||
                this.canInsertParticipanteCentralCompra;
    }
}
